import { roleIndexValidate } from "../../application/dtos/role_index_validate";

export class roleIndexEntity {
    constructor({ id, name, is_for_clients }){
        this.id = id;
        this.name = name;
        this.is_for_clients = is_for_clients;
    }

    isValid() {
        return roleIndexValidate(this);
    }
}